import type React from 'react';
import classNames from '../../../../../utils/classNames';

/** Orange while a quota is nearing its limit, red once the limit is reached. */
export function getUsageSeverityClasses(isLimit: boolean): { text: string; bar: string } {
    return isLimit
        ? { text: 'text-error', bar: 'bg-error' }
        : { text: 'text-warning', bar: 'bg-warning' };
}

interface UsageProgressBarProps {
    percent: number;
    ariaLabel: string;
    fillClassName?: string;
}

export function UsageProgressBar({
    percent,
    ariaLabel,
    fillClassName = 'bg-primary',
}: UsageProgressBarProps): React.ReactElement {
    return (
        <div
            className="h-1.5 w-32 overflow-hidden rounded-full bg-gray-200"
            role="img"
            aria-label={ariaLabel}
        >
            <div
                className={classNames(
                    'h-full rounded-full transition-[width] duration-200',
                    fillClassName
                )}
                style={{ width: `${Math.min(percent, 100)}%` }}
            />
        </div>
    );
}
